import {
	User
} from "~/node_modules/sitisjs/dist/internal/sections/users/models/User";

export const state = () => ({
	isOpenAuth: false,
	isOpenRegist: false,
});

export const mutations = {
	setOpen: function (state, {name, value}) {
		state[name] = value;
	}
};
